import PropTypes from 'prop-types'
import React from 'react'
import { imagesCDN } from 'Core/constants'
import Link from 'next/link'
import { connect } from 'react-redux'
import { isUserOnline } from 'SRC/utils'
import { getIsMobileDevice } from 'SRC/modules/common/selectors'
import { getAdsCount, getMainAddress, getLinkAs, getLinkHref } from '../../../functions'

const Item = ({
  name,
  logo: { fd },
  active,
  userAddresses,
  username,
  seo,
  userTypeSeo,
  adsCategories,
  category,
  className,
  premium,
  isMobileDevice
}) => {

  const getName = (name, isPremium) => {
    if (isPremium) {
      if (!isMobileDevice) return <a>{name.length < 30 ? name : `${name.substr(0, 29)}...`}</a>

      return <a>{name.length < 21 ? name : `${name.substr(0, 25)}...`}</a>
    } else {
      return <a>{name.length < 25 ? name : `${name.substr(0, 24)}...`}</a>
    }
  }

  return <div className={className}>
    <div className='user-header'>
      <Link
        href={getLinkHref({ username, seo, userTypeSeo, category })}
        as={getLinkAs({ username, seo, userTypeSeo, category })}
      >
        {name ? getName(name, premium) : 'Korisnik'}
      </Link>
    </div>
    <div className='user-content'>
      <div className='user-img'>
        <Link
          href={getLinkHref({ username, seo, userTypeSeo, category })}
          as={getLinkAs({ username, seo, userTypeSeo, category })}
        >
          <a>
            {fd ? (
              <img src={`${imagesCDN}${fd}`} alt={username} />
            ) : (
              <img src='/icons/no-image-placeholder.svg' alt='no-image-placeholder' />
            )}
          </a>
        </Link>
      </div>
      <div className='user-info'>
        <div className='user-status'>
          <span>{username}</span>
          <span className='user-online-status-text'>
            {isUserOnline(active) ? `Online` : `Offline`} &nbsp;
            <span className={`user-online-status ${isUserOnline(active) ? `online` : `offline`}`} />
          </span>
        </div>
        <div className='user-broj-artikala'>
          <Link
            href={getLinkHref({ username, seo, userTypeSeo, category })}
            as={getLinkAs({ username, seo, userTypeSeo, category })}
          >
            <a>{getAdsCount(adsCategories)} oglasa</a>
          </Link>
        </div>
        <div className='user-lokacija'>
          <i className='ico-lokacija ico' />
          <p>
            {getMainAddress(userAddresses)} {userAddresses.length > 1 ? `(+${userAddresses.length - 1})` : null}
          </p>
        </div>
      </div>
    </div>
  </div>
}

Item.propTypes = {
  userAddresses: PropTypes.arrayOf(PropTypes.shape({
    isMain: PropTypes.bool,
    city: PropTypes.shape({
      name: PropTypes.string.isRequired
    })
  })).isRequired,
  logo: PropTypes.shape({
    fd: PropTypes.string
  }),
  active: PropTypes.string,
  premium: PropTypes.bool,
  name: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  seo: PropTypes.string.isRequired,
  userTypeSeo: PropTypes.string.isRequired,
  adsCategories: PropTypes.shape({
    count: PropTypes.number
  }),
  category: PropTypes.string.isRequired,
  className: PropTypes.string,
  isMobileDevice: PropTypes.string.isRequired
}

Item.defaultProps = {
  userAddresses: [],
  premium: false,
  logo: {},
  category: ''
}

const mapStateToProps = state => {
  return {
    isMobileDevice: getIsMobileDevice(state)
  }
}

export default connect(mapStateToProps)(Item)
